/**
 * Shared, reusable contact-channel pills (Phone / SMS / WhatsApp).
 * Phone is the toll-free number; SMS + WhatsApp route to the mobile line so
 * folks who prefer typing can reach the same human a different way.
 */
import { ChatCircleText, Phone, WhatsappLogo } from "@phosphor-icons/react";

export const PHONE_NUMBER = "1.844.606.1100";
export const PHONE_TEL = "tel:+18446061100";
export const TEXT_NUMBER = "1-416-805-5800";
export const SMS_HREF = "sms:+14168055800";
export const WHATSAPP_HREF = "https://wa.me/14168055800";

export default function ContactChannels({ variant = "light", compact = false, layout = "row", testIdPrefix = "channel" }) {
  const isDark = variant === "dark";
  const wrap = layout === "row" ? "flex flex-wrap items-center gap-2" : "flex flex-col gap-2";
  const pill = compact
    ? `inline-flex items-center justify-center gap-1.5 px-2.5 py-1.5 text-xs font-semibold rounded-sm transition-colors border ${
        isDark
          ? "border-white/30 text-white hover:bg-white hover:text-ink"
          : "border-ink text-ink hover:bg-ink hover:text-white"
      }`
    : `inline-flex items-center justify-center gap-2 px-4 py-2.5 text-sm font-semibold rounded-sm transition-colors border ${
        isDark
          ? "border-white/30 text-white hover:bg-white hover:text-ink"
          : "border-ink text-ink hover:bg-ink hover:text-white"
      }`;

  const iconSize = compact ? 14 : 16;

  return (
    <div className={wrap} data-testid={`${testIdPrefix}-group`}>
      <a href={PHONE_TEL} className={pill} data-testid={`${testIdPrefix}-call`}>
        <Phone size={iconSize} weight="fill" /> Call · {PHONE_NUMBER}
      </a>
      <a href={SMS_HREF} className={pill} data-testid={`${testIdPrefix}-sms`}>
        <ChatCircleText size={iconSize} weight="fill" /> SMS
      </a>
      <a href={WHATSAPP_HREF} target="_blank" rel="noopener noreferrer" className={pill} data-testid={`${testIdPrefix}-whatsapp`}>
        <WhatsappLogo size={iconSize} weight="fill" /> WhatsApp
      </a>
    </div>
  );
}
